__turbopack_context__.v({
  "container": "snackbar-module-scss-module__sf-IxG__container",
});
